import React from "react";
import T from "prop-types";

import { DoplnkoveSluzbyNazev } from "b2b/renderers";
import { Projekt, Produkt } from "b2b/renderers/ciselnik";
import Buttons from "2g-buttons";
import { Icons } from "2g-icons";

import useZadostiRowDetail from "./hooks/useZadostiRowDetail";
import ZadostiRowDetailColumn from "./ZadostiRowDetailColumn";
import ZadostiRowDetailItem from "./ZadostiRowDetailItem";
import ZadostiRowPoznamka from "./ZadostiRowPoznamka";

export function ZadostiRowDetail({ dataRow }) {
  const { handleClickDetail } = useZadostiRowDetail({ id: dataRow.id });
  return (
    <div className="b2b-ZadostiRowDetail">
      <div className="b2b-ZadostiRowDetail-content">
        <ZadostiRowDetailColumn classname="b2b-ZadostiRowDetail-items">
          <ZadostiRowDetailItem label="b2b.zadosti-row-detail.telefon.label">
            {dataRow.zadavatel.uzivatel.telefon}
          </ZadostiRowDetailItem>
          <ZadostiRowDetailItem label="b2b.zadosti-row-detail.email.label">
            {dataRow.zadavatel.uzivatel.email}
          </ZadostiRowDetailItem>
          <ZadostiRowDetailItem label="b2b.zadosti-row-detail.projekt.label">
            <Projekt val={dataRow.projekt} />
          </ZadostiRowDetailItem>
          <ZadostiRowDetailItem label="b2b.zadosti-row-detail.produkt.label">
            <Produkt val={dataRow.produkt} />
          </ZadostiRowDetailItem>
          <ZadostiRowDetailItem label="b2b.zadosti-row-detail.doplnkove-sluzby.label">
            <DoplnkoveSluzbyNazev val={dataRow.doplnkoveSluzby} />
          </ZadostiRowDetailItem>
        </ZadostiRowDetailColumn>
        <ZadostiRowDetailColumn
          classname="b2b-ZadostiRowDetail-notes"
          label="b2b.zadosti-row-detail.poznamky.label"
        >
          <ZadostiRowPoznamka
            label="b2b.zadosti-row-detail.poznamky-zakaznik.label"
            poznamka={dataRow.poznamkaZakaznik}
          />
          <ZadostiRowPoznamka
            label="b2b.zadosti-row-detail.poznamky-strojvedouci.label"
            poznamka={dataRow.strojvedouci}
          />
          <ZadostiRowPoznamka
            label="b2b.zadosti-row-detail.poznamky-spravce.label"
            poznamka={dataRow.poznamkaSpravce}
          />
        </ZadostiRowDetailColumn>
      </div>
      <div className="b2b-ZadostiRowDetail-action">
        <Buttons.Primary inverse rounded onClick={handleClickDetail}>
          <Icons.ArrowDouble />
        </Buttons.Primary>
      </div>
    </div>
  );
}

ZadostiRowDetail.propTypes = { dataRow: T.object.isRequired };

export default React.memo(ZadostiRowDetail);
